import { render, staticRenderFns } from "./candy-planets.vue?vue&type=template&id=8a46fe3a&"
import script from "./candy-planets.vue?vue&type=script&lang=js&"
export * from "./candy-planets.vue?vue&type=script&lang=js&"
import style0 from "./candy-planets.vue?vue&type=style&index=0&id=8a46fe3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports